import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import log from "../images/k-bakery-logo.jpeg";
import { FaRegUserCircle, FaShoppingBag } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { setToken, clearToken } from "../redux/userSlice";
import { toast } from "react-hot-toast";
import Cookies from "js-cookie";

const Header = () => {
  const [showMenu, setShowMenu] = useState(false);
  const dispatch = useDispatch();

  const token = useSelector((state) => state.user.token);

  useEffect(() => {
    const localToken = localStorage.getItem("token");
    const localEmail = localStorage.getItem("email");
    const localFirstName = localStorage.getItem("firstName");
    const localIsAdmin = localStorage.getItem("isAdmin") === "true";
    
    if (localToken && !token) {
      dispatch(setToken({
        token: localToken,
        email: localEmail,
        firstName: localFirstName,
        isAdmin: localIsAdmin
      }));
    }
  }, [token, dispatch]);
  const cartItemNumber=useSelector((state)=>state.product.cartItem)

  const handleShowMenu = () => setShowMenu((prev) => !prev);

  const handleLogout = () => {
    dispatch(clearToken());
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("firstName");
    localStorage.removeItem("isAdmin");
    Cookies.remove("token");
    toast("Logged out!");
    setShowMenu(false);
  };

  const user = useSelector((state) => state.user);
  const isAdmin = user?.isAdmin;

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white backdrop-blur-xl border-b border-[#FFB4AB]/20 shadow-sm">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to={"/"} className="h-12 flex items-center gap-3">
            <img src={log} alt="K Bakery Logo" className="h-16 w-auto object-contain" />
            <span className="font-bold text-xl text-[#2D2D2D] tracking-wide hidden md:block">
              K Bakery
            </span>
          </Link>
          
          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8 text-[#2D2D2D] font-medium">
            <Link to={"/"} className="relative group transition">
              Home
              <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-gradient-to-r from-[#FFB4AB] to-[#E5DEFF] group-hover:w-full transition-all duration-300"></span>
            </Link>
            <Link to={"menu"} className="relative group transition">
              Menu
              <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-gradient-to-r from-[#FFB4AB] to-[#E5DEFF] group-hover:w-full transition-all duration-300"></span>
            </Link>
            <Link to={"about"} className="relative group transition">
              About
              <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-gradient-to-r from-[#FFB4AB] to-[#E5DEFF] group-hover:w-full transition-all duration-300"></span>
            </Link>
            <Link to={"contact"} className="relative group transition">
              Contact
              <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-gradient-to-r from-[#FFB4AB] to-[#E5DEFF] group-hover:w-full transition-all duration-300"></span>
            </Link>
            <Link to={"gallery"} className="relative group transition">
              Gallery
              <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-gradient-to-r from-[#FFB4AB] to-[#E5DEFF] group-hover:w-full transition-all duration-300"></span>
            </Link>
          </nav>

          {/* Right Section */}
          <div className="flex items-center gap-5 relative">
            {/* Order Now */}
            <Link
              to={"/cart"}
              className="flex items-center gap-2 bg-[#740D0D] hover:bg-[#590a0a] text-white rounded-full px-4 h-10 font-medium shadow-md hover:shadow-lg transition-all"
            >
              <FaShoppingBag className="text-lg" /><div className='absolute -top-0 -right-1 left-7 text-black bg-white h-4 w-4 rounded-full m-0 p-0 text-xs text-center'>
                            {cartItemNumber.length}
                            </div>  
              Order Now
            </Link>

            {/* User */}
            <div className="relative">
              <button
                onClick={handleShowMenu}
                className=" w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-br from-[#FFB4AB]/20 to-[#E5DEFF]/20 border border-[#FFB4AB]/30 hover:shadow-md transition"
              >
                <FaRegUserCircle className="text-[#2D2D2D] text-2xl" />
              </button>

              {/* Dropdown */}
              {showMenu && (
                <div className="absolute right-0 mt-3 bg-white border border-[#FFB4AB]/20 rounded-xl shadow-lg overflow-hidden min-w-[160px] backdrop-blur-lg animate-fadeIn">
                  {isAdmin && (
                    <div className="bg-pink-50/50 border-b border-[#FFB4AB]/10">
                      <p className="px-4 py-2 text-[10px] font-bold text-pink-400 uppercase tracking-wider">Admin Panel</p>
                      <Link
                        to={"newproduct"}
                        className="block px-4 py-2 text-sm hover:bg-[#FFB4AB]/10 transition text-[#2D2D2D]"
                        onClick={() => setShowMenu(false)}
                      >
                        New Product
                      </Link>
                      <Link
                        to={"manage"}
                        className="block px-4 py-2 text-sm hover:bg-[#FFB4AB]/10 transition text-[#2D2D2D]"
                        onClick={() => setShowMenu(false)}
                      >
                        Manage Orders
                      </Link>
                      <Link
                        to={"admin-categories"}
                        className="block px-4 py-2 text-sm hover:bg-[#FFB4AB]/10 transition text-[#2D2D2D]"
                        onClick={() => setShowMenu(false)}
                      >
                        Manage Categories
                      </Link>
                      <Link
                        to={"offer-management"}
                        className="block px-4 py-2 text-sm hover:bg-[#FFB4AB]/10 transition text-[#2D2D2D]"
                        onClick={() => setShowMenu(false)}
                      >
                        Manage Offers
                      </Link>
                      <Link
                        to={"admin-messages"}
                        className="block px-4 py-2 text-sm hover:bg-[#FFB4AB]/10 transition text-[#2D2D2D]"
                        onClick={() => setShowMenu(false)}
                      >
                        Messages
                      </Link>
                      <Link
                        to={"admin-gallery"}
                        className="block px-4 py-2 text-sm hover:bg-[#FFB4AB]/10 transition text-[#2D2D2D]"
                        onClick={() => setShowMenu(false)}
                      >
                        Manage Gallery
                      </Link>
                      <Link
                        to={"admin-users"}
                        className="block px-4 py-2 text-sm hover:bg-[#FFB4AB]/10 transition text-[#2D2D2D]"
                        onClick={() => setShowMenu(false)}
                      >
                        View Users
                      </Link>
                    </div>
                  )}

                  {token ? (
                    <>
                      <Link
                        to={"/profile"}
                        className="block px-4 py-2 text-sm hover:bg-[#FFB4AB]/10 transition text-[#2D2D2D]"
                        onClick={() => setShowMenu(false)}
                      >
                        Profile
                      </Link>
                    <Link to={"/orders"} className="block px-4 py-2 text-sm hover:bg-[#FFB4AB]/10 transition text-[#2D2D2D]"
                      onClick={() => setShowMenu(false)}
                    >
                      Orders
                    </Link>
                    <Link to={"/my-messages"} className="block px-4 py-2 text-sm hover:bg-[#FFB4AB]/10 transition text-[#2D2D2D]"
                      onClick={() => setShowMenu(false)}
                    >
                      My Messages
                    </Link>
                      <p
                        onClick={handleLogout}
                        className="block px-4 py-2 text-sm text-rose-500 hover:bg-rose-50 cursor-pointer transition"
                      >
                        Logout
                      </p>
                    </>
                  ) : (
                    <Link
                      to={"login"}
                      className="block px-4 py-2 text-sm hover:bg-[#FFB4AB]/10 transition text-[#2D2D2D]"
                      onClick={() => setShowMenu(false)}
                    >
                      Login
                    </Link>
                  )}

                  {/* Mobile nav inside dropdown */}
                  <div className="md:hidden border-t border-[#FFB4AB]/20 mt-2">
                    <Link to={"/"} className="block px-4 py-2 text-sm hover:bg-[#FFB4AB]/10 transition" onClick={() => setShowMenu(false)}>Home</Link>
                    <Link to={"menu"} className="block px-4 py-2 text-sm hover:bg-[#FFB4AB]/10 transition" onClick={() => setShowMenu(false)}>Menu</Link>
                    <Link to={"about"} className="block px-4 py-2 text-sm hover:bg-[#FFB4AB]/10 transition" onClick={() => setShowMenu(false)}>About</Link>
                    <Link to={"contact"} className="block px-4 py-2 text-sm hover:bg-[#FFB4AB]/10 transition" onClick={() => setShowMenu(false)}>Contact</Link>
                    <Link to={"gallery"} className="block px-4 py-2 text-sm hover:bg-[#FFB4AB]/10 transition" onClick={() => setShowMenu(false)}>Gallery</Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
